// Configurações globais padrão (fallback)
export const defaultSettings = {
    capacidade: { almoco: 80, jantar: 80 },
    horarios: {
        almoco: {
            turnosAtivos: false,
            horarioCompleto: { inicio: '12:00', fim: '15:00' },
            turno1: { inicio: '12:00', fim: '13:30' },
            turno2: { inicio: '13:30', fim: '15:00' }
        },
        jantar: {
            turnosAtivos: true,
            horarioCompleto: { inicio: '19:00', fim: '23:00' },
            turno1: { inicio: '19:00', fim: '21:00' },
            turno2: { inicio: '21:00', fim: '23:00' }
        }
    },
    descontos: {
        ativo: true,
        limiteReservasOnline: {
            almoco: { total: 40, turno1: 20, turno2: 20 },
            jantar: { total: 50, turno1: 25, turno2: 25 },
        },
        lugaresPorServico: {
            almoco: { total: 20, turno1: 10, turno2: 10 },
            jantar: { total: 30, turno1: 15, turno2: 15 },
        },
        escaloes: [
            { id: 'default-esc-1', atePessoas: 10, percentagem: 35 },
            { id: 'default-esc-2', atePessoas: 10, percentagem: 15 },
        ],
        agendamento: {
            // CORREÇÃO: O mês de Julho está agora ativo por defeito.
            mesesAtivos: { jan: true, fev: true, mar: true, abr: true, mai: true, jun: true, jul: true, ago: false, set: true, out: true, nov: true, dez: true },
            diasSemana: { seg: true, ter: true, qua: true, qui: true, sex: false, sab: false, dom: false },
            semanasMes: { sem1: true, sem2: true, sem3: true, sem4: true, sem5: true },
            turnosServico: { almoco: true, jantar: true }
        }
    }
};
